export default __webpack_public_path__ + "static/media/Twitter-Cover-1200-x-675px-.d670d162.png";